<template>
  <header>
    <a class="logo" title="Hlavní stránka" href="#dashboard">
      <img src="/logo-transparent.png" alt="logo" />
    </a>
    <nav class="menu">
      <a v-for="(icon, name, index) in menu_items[login.role]" :key="index" :href="`#${name}`" :class="{ active: name == path }" :title="$options.filters.cz(name)">
        <span class="title">{{ name | cz }}</span>
        <i :class="`fas fa-${icon}`"></i>
      </a>
    </nav>
    <a v-if="login.role == 'User'" class="manual" title="Návod"
      href="https://docs.google.com/document/d/1n6S7fpr6OSya595Lk_GaT0GMnQPzD14PiUNYjukW54M/edit?usp=sharing"
      target="_blank"><i class="fa fa-question-circle"></i></a>
    <a v-if="login.role == 'User'" class="finance" title="Přehled financí" href="#finance">{{ financeLabel }}: {{
      Math.abs(remains)
    }} Kč</a>
    <div v-if="isChanged" class="changes">
      <button class="save" @click="save">Uložit</button>
      <button class="reset" @click="reset">Vrátit změny</button>
    </div>
    <a v-if="login.role == 'User'" class="outpost" title="Detail hlídky" href="#outpost">{{ outpost.id }}. PH - {{
      outpost.city
    }}</a>
    <div class="logout" title="Odhlásit" @click="logout">
      <i class="fas fa-sign-out-alt"></i>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "topPanel",
  data: () => ({
    menu_items: {
      User: {
        dashboard: 'columns',
        participants: 'user',
        accommodation: 'home',
        teams: 'users',
        larp_teams: 'users',
        boardgames: 'chess',
        more: 'hashtag',
        activities: 'star',
      },
      Finance: {
        pays: 'receipt'
      },
      Admin: {
        users: 'users',
        outposts: 'flag',
        servants: 'handshake',
        accommodationOrders: 'home',
        accommodation: 'home',
        pays: 'receipt',
        modifiers: 'dollar-sign',
        buses: 'bus',
        waves: 'cookie',
        activities: 'star',
        tournament: 'chess',
        fields: 'map',
        ages: 'calendar',
        config: 'wrench',
      },
      Judge: {
        myMatches: 'gavel',
        freeMatches: 'eye ',
        allMatches: 'globe',
        teams: 'users',
        map: 'map',
      },
    }
  }),
  computed: {
    ...mapState(["path", "login", "outpost"]),
    ...mapGetters(["isChanged", "remains"]),
    financeLabel() {
      if (this.remains >= 0) return "Zbývá doplatit";

      return "Přeplatek";
    }
  },
  methods: {
    save() {
      this.$store.dispatch("save");
    },
    reset() {
      this.$store.commit("reset");
    },
    logout() {
      this.$store.commit("logout");
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_constants
$padding: 1rem
$font-size: 1.2rem
$menu-overflow: 0.5rem

@mixin menuItem()
  display: block
  padding: $padding

  text-transform: capitalize
  transition: color .5s, margin-bottom .5s, background-color .5s
  font-weight: bold
  &.active
    margin-bottom: -$menu-overflow
    padding-bottom: $padding + $menu-overflow
    background-color: $bc-secondary
  &:hover
    color: #eee

header
  display: grid
  height: $font-size + (2 * $padding)
  padding: 0 1rem
  margin-bottom: 2rem
  font-size: $font-size
  background-color: $bc-primary

  grid-auto-flow: column
  grid-template-columns: max-content 1fr max-content max-content max-content
  grid-column-gap: 10px
  align-items: center

  .logo
    height: 3rem
    img
      height: 100%
      width: auto
  .menu
    display: flex
    height: $font-size + (2 * $padding)
    a
      @include menuItem()
      span
        font-weight: inherit
      i
        display: none
  .manual
    transition: color .5s
    &:hover
      color: #fff
  .finance
    padding: $padding + ($menu-overflow / 2) $padding
    margin-bottom: -$menu-overflow
    background-color: $bc-secondary
    transition: color .5s
    &:hover
      color: #fff
  .changes
    .save, .reset
      padding: $padding + ($menu-overflow / 2) $padding
      margin-bottom: -$menu-overflow
      cursor: pointer
    .save
      background-color: $bc-warning
    .reset
      background-color: $bc-danger
  .outpost
    @include menuItem()
  .logout
    @include menuItem()
    cursor: pointer

@media only screen and (max-width: 1000px)
  header
    padding: 0 3px

    .menu a
      span
        display: none
      i
        display: inline
</style>